export const contactSectionFields = () => {
  return [
    {
      name: 'name',
      id: 'name',
      placeholder: 'Name',
      label: 'Name',
      type: 'string',
      required: 'Enter name',
      fieldType: 'textfield',
      min: 3,
      minMessage: 'Name must be at least 3 characters',
      max: 30,
      maxMessage: 'Name must be at most 30 characters',
      match: /[a-zA-Z]+/,
      matchMessage: 'Name must contain at least one character'
    },
    {
      name: 'email',
      id: 'email',
      placeholder: 'Email ID',
      label: 'Email ID',
      type: 'string',
      required: 'Enter email ID',
      fieldType: 'textfield',
      match: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      matchMessage: 'Enter valid email ID',
      email: 'Enter valid email ID'
    },
    {
      name: 'phone',
      id: 'phone',
      placeholder: 'Mobile Number',
      label: 'Mobile Number',
      type: 'string',
      required: 'Enter mobile number',
      match: /^([0|+[0-9]{1,5})?([6-9][0-9]{9})$/,
      matchMessage: 'Enter valid mobile number'
    },
    {
      name: 'message',
      id: 'message',
      placeholder: 'Message',
      label: 'Message',
      type: 'string',
      required: 'Enter Message',
      min: 10,
      minMessage: 'Message must be at least 10 characters',
      match: /^[A-Za-z .-]+(\s*[A-Za-z .-]+)*$/,
      matchMessage: 'Enter valid message'
    }
  ];
};
